import { BasicAvatarSteam } from './basic'
import { PlusAvatarSteam } from './plus'
import { AvatarProps } from './types'

export const AvatarSteam = (props: AvatarProps) => {
  const { isPlusUser, src, alt, isSteamLogo, width, height, border, borderRadius } = props

  if (isPlusUser)
    return (
      <PlusAvatarSteam
        src={src}
        alt={alt}
        isSteamLogo={isSteamLogo}
        width={width}
        height={height}
        border={border}
        borderRadius={borderRadius}
      />
    )
  return (
    <BasicAvatarSteam
      src={src}
      alt={alt}
      isSteamLogo={isSteamLogo}
      width={width}
      height={height}
      border={border}
      borderRadius={borderRadius}
    />
  )
}
